import Row from 'components/core/Row'
import { WidgetComponentProps } from '../../wilsonChat.types'
import { useState } from 'react'
import { WIDGET_KEY } from '../widget.constants'
import Button from 'components/core/Button'
import Column from 'components/core/Column'
import Typography from 'components/core/Typography'
import { HtmlEditor } from 'components/core/HtmlEditor'

export type SendConciergeWidgetData = {
    htmlContent: string
    status?: 'sent' | 'cancelled'
}

export type SendConciergeWidgetProps = WidgetComponentProps<
    'SendConciergeMessage',
    SendConciergeWidgetData
>

export const SendConciergeWidget = ({
    messageId,
    widgetData,
    onSendMessage,
}: SendConciergeWidgetProps) => {
    const [htmlContent, setHtmlContent] = useState<string>(
        widgetData.htmlContent
    )

    const _onSend = () => {
        onSendMessage({
            message: '[Action: SendConciergeMessage]',
            payload: {
                replyToWidget: WIDGET_KEY.sendConciergeMessage,
                replyToMessageId: messageId,
                widgetData: {
                    htmlContent,
                    status: 'sent',
                },
            },
        })
    }

    const _onCancel = () => {
        onSendMessage({
            message: '[Action: CancelConciergeMessage]',
            payload: {
                replyToWidget: WIDGET_KEY.sendConciergeMessage,
                replyToMessageId: messageId,
                widgetData: {
                    htmlContent,
                    status: 'cancelled',
                },
            },
        })
    }

    if (widgetData.status) {
        return (
            <Column gap="p1" p="p2">
                <HtmlEditor
                    // weird issue with StyledQuill.
                    // it does not re-render properly so had to add a key to force re-render
                    // when the status changes
                    key={widgetData.status}
                    readOnly
                    fullHeight
                    value={htmlContent}
                    toolbarOptions={[]}
                />
                <Row gap="p1" justifyContent="flex-end">
                    <Typography isItalic variant="body2" color="secondary">
                        {widgetData.status === 'sent'
                            ? 'Sent'
                            : 'Cancelled draft concierge message'}
                    </Typography>
                </Row>
            </Column>
        )
    }

    return (
        <Column gap="p1" p="p2">
            <HtmlEditor
                fullHeight
                value={htmlContent}
                toolbarOptions={[
                    'bold',
                    'italic',
                    'underline',
                    'bulletList',
                    'numberedList',
                    'link',
                ]}
                onChange={setHtmlContent}
            />
            <Row gap="p1" justifyContent="space-between" alignItems="center">
                <Row gap="p1" justifyContent="flex-end">
                    <Button variant="secondary" onClick={_onCancel}>
                        Cancel
                    </Button>
                    <Button variant="primary" onClick={_onSend}>
                        Send
                    </Button>
                </Row>
            </Row>
        </Column>
    )
}
